import { Box, MenuItem, TextField } from "@mui/material";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import SymbolType from "@warriortrading/warriortrading.hermes.common.feathers/enums/symbolType";
import { useState } from "react";

export const SymbolCreate = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    setValue,
    formState: { errors },
  } = useForm();

  const [symbolType, setSymbolType] = useState("");
  const [symbolName, setSymbolName] = useState("");

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          required
          margin="normal"
          fullWidth
          value={symbolName}
          onChange={(e)=>{
            setSymbolName(e.target.value);
            setValue('symbol', e.target.value.toUpperCase())
          }}
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Symbol"
          name="symbol"
        />
        <TextField
          {...register("prevSymbol", {})}
          error={!!(errors as any)?.prevSymbol}
          helperText={(errors as any)?.prevSymbol?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="PrevSymbol"
          name="prevSymbol"
        />
        <TextField
          required
          select
          defaultValue={''}
          value={symbolType ?? ""}
          margin="normal"
          label="Type"
          onChange={(e) => {
            setSymbolType(e.target.value);
            setValue("type", e.target.value);
          }}
        >
          {Object.values(SymbolType)[0].map((option: any) => (
            <MenuItem key={option.value} value={option.name.toLowerCase()}>
              {option.name.toLowerCase()}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          {...register("company", {})}
          error={!!(errors as any)?.company}
          helperText={(errors as any)?.company?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Company"
          name="company"
        />
        <TextField
          {...register("op", {})}
          error={!!(errors as any)?.op}
          helperText={(errors as any)?.op?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Op"
          name="op"
        />
        <TextField
          {...register("comments", {})}
          error={!!(errors as any)?.comments}
          helperText={(errors as any)?.comments?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Comments"
          name="comments"
        />
      </Box>
    </Create>
  );
};
